import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { NgErrorHandler } from './error-handler/ng-error-handler';
import { ApiErrorInterceptor } from './interceptors/api-error.interceptor';
import { BlobErrorInterceptor } from './interceptors/blob-error.interceptor';
import * as i0 from "@angular/core";
export let CoreErrorModule = /*#__PURE__*/(() => {
  class CoreErrorModule {
    static {
      this.ɵfac = function CoreErrorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreErrorModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreErrorModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [{
          provide: HTTP_INTERCEPTORS,
          multi: true,
          useClass: ApiErrorInterceptor
        }, {
          provide: HTTP_INTERCEPTORS,
          multi: true,
          useClass: BlobErrorInterceptor
        }, {
          provide: ErrorHandler,
          useClass: NgErrorHandler
        }]
      });
    }
  }
  return CoreErrorModule;
})();